import { FC } from 'react';
import { SubscriptionStore } from '../../stores/subscription.store';
import { Form, BodyText, Button, Headline, Card } from '@servicetitan/design-system';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import classnames from 'classnames';
import * as Styles from '../page-wrapper/page-wrapper.module.less';

export const Preferences: FC = observer(() => {
    const [marketingStore] = useDependencies(SubscriptionStore);

    const handleUpdateSubscription = () => {
        marketingStore.updatePreferences();
    };

    const getCheckbox = (label: string, name: string, state: FieldState<boolean>) => {
        return (
            <Form.Checkbox
                size="medium"
                label={label}
                onChange={(_, checked) => state.onChange(checked)}
                checked={state.value}
                className={`qa-preferences-${name.toLowerCase()}-button`}
            />
        );
    };

    const options = marketingStore.optionsForm.$;
    return (
        <Card raised className={classnames(Styles.card, 'qa-page-main-card')}>
            <Headline size="large" className="m-b-4">
                Update Email Subscriptions
            </Headline>
            <BodyText className="m-b-2">
                Select the email categories you would like to subscribe.
            </BodyText>
            <Form className="qa-preference-preference-form">
                <Form.Group grouped>
                    {getCheckbox('Estimate follow-ups', 'UnsoldEstimates', options.unsoldEstimates)}
                    {getCheckbox(
                        'Equipment service check-ins',
                        'AgingEquipment',
                        options.agingEquipment
                    )}
                    {getCheckbox(
                        'Membership reminders',
                        'ExpiringMemberships',
                        options.expiringMemberships
                    )}
                    {getCheckbox(
                        "“Haven't heard from you” reminders",
                        'IdleAccount',
                        options.idleAccount
                    )}
                    {getCheckbox(
                        'Recurring service reminders',
                        'RecurringServices',
                        options.recurringService
                    )}
                    {getCheckbox('Newsletters', 'Newsletter', options.newsletter)}
                    {getCheckbox('Thank yous', 'ThankYou', options.thankYou)}
                    {getCheckbox('Welcomes', 'CustomerWelcome', options.customerWelcome)}
                    {getCheckbox('Special announcements', 'Other', options.other)}
                    {getCheckbox('Market to leads', 'MarketToLeads', options.marketToLeads)}
                </Form.Group>
            </Form>
            <Button
                className="qa-update-preference-button m-t-3"
                onClick={handleUpdateSubscription}
                disabled={!marketingStore.canSubmit}
                primary
                full
            >
                Update Email Subscriptions
            </Button>
        </Card>
    );
});
